/* TwentySix quick add sheet (snippets/cc-quick-add-sheet.liquid) */
(function () {
  if (window.ccQuickAddInit) return;
  window.ccQuickAddInit = true;

  var overlay = document.querySelector('[data-cc-qa-overlay]');
  var body = overlay ? overlay.querySelector('[data-cc-qa-body]') : null;
  var sheet = overlay ? overlay.querySelector('.cc-qa-sheet') : null;
  var handle = overlay ? overlay.querySelector('[data-cc-qa-handle]') : null;
  var lightbox = document.querySelector('[data-cc-qa-lightbox]');
  var lightboxTrack = lightbox ? lightbox.querySelector('[data-cc-qa-lightbox-track]') : null;
  if (!overlay || !body || !sheet) return;

  var currentProduct = null;
  var selectedOptions = [];
  var currentSiblings = []; // combined-listing sibling colors [{name, option, handle}]

  function money(cents) {
    // the store's format: 150₪ (no decimals when whole)
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return amount + '₪';
  }

  // Append/replace a width parameter on a Shopify CDN image URL for crisp rendering
  function sizedImage(src, width) {
    if (!src) return src;
    try {
      var hasQuery = src.indexOf('?') !== -1;
      // strip any existing width param, then add ours
      var clean = src.replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, '');
      var sep = clean.indexOf('?') !== -1 ? '&' : '?';
      return clean + sep + 'width=' + width;
    } catch (e) {
      return src;
    }
  }

  function isDesktop() { return window.matchMedia('(min-width: 750px)').matches; }
  function reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  // the photos in the sheet are small on phones (a third of the width), so they load small and fast
  function galleryWidth() { return isDesktop() ? 1000 : 480; }

  /* the page stays exactly where it is under the sheet: nothing on the page itself changes (no position:fixed, no
     overflow:hidden; both moved the page or hid the sticky header on iPhone). Touches and wheel on the dim layer
     simply don't scroll, and the sheet's own scroll areas never hand their scroll on to the page (CSS overscroll). */
  var locked = false;
  function lockBody() { locked = true; }
  function unlockBody() { locked = false; }
  overlay.addEventListener('wheel', function (e) {
    if (e.target.closest('.cc-qa-layout, .cc-qa-gallery, .cc-qa-info')) return;
    if (e.cancelable) e.preventDefault();
  }, { passive: false });
  overlay.addEventListener('touchmove', function (e) {
    if (e.target.closest('.cc-qa-layout, .cc-qa-gallery, .cc-qa-info, .cc-qa-handle')) return;
    if (e.cancelable) e.preventDefault();
  }, { passive: false });

  var closeTimer = null;
  var enterTimer = null;
  function openSheet() {
    clearTimeout(closeTimer);
    ensureStyles();
    overlay.hidden = false;
    lockBody();
    sheet.style.transition = '';
    sheet.style.transform = '';
    overlay.style.transition = '';
    overlay.style.opacity = '';
  }
  // the content is already in place when the sheet starts to rise, so it rises once, at its final height
  function revealSheet() {
    clearTimeout(enterTimer);
    body.classList.remove('cc-qa-swap');
    if (!reducedMotion()) body.classList.add('cc-qa-enter');
    void sheet.offsetHeight;
    requestAnimationFrame(function () {
      overlay.classList.add('cc-qa-open');
    });
    enterTimer = setTimeout(function () { body.classList.remove('cc-qa-enter'); }, 1100);
  }

  function closeSheet() {
    overlay.classList.remove('cc-qa-open');
    clearTimeout(closeTimer);
    lastHandle = null;
    closeTimer = setTimeout(function () {
      overlay.hidden = true;
      body.innerHTML = '';
      body.classList.remove('cc-qa-enter', 'cc-qa-swap', 'cc-qa-wait');
      sheet.style.transition = '';
      sheet.style.transform = '';
      overlay.style.transition = '';
      overlay.style.opacity = '';
      // only unlock if the lightbox isn't still open on top
      if (!lightbox || lightbox.hidden) unlockBody();
    }, 360);
  }

  // --- Fullscreen image viewer (lightbox) ---
  function openLightbox(images, startIndex) {
    if (!lightbox || !lightboxTrack || !images || !images.length) return;
    lightboxTrack.innerHTML = images.map(function (src) {
      return '<img src="' + sizedImage(src, 1600) + '" alt="" loading="eager">';
    }).join('');
    lightbox.hidden = false;
    // body is already locked by the sheet; nothing extra needed
    requestAnimationFrame(function () {
      lightbox.classList.add('cc-qa-lightbox--open');
      var target = lightboxTrack.children[startIndex || 0];
      if (target) lightboxTrack.scrollLeft = target.offsetLeft;
    });
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('cc-qa-lightbox--open');
    setTimeout(function () {
      lightbox.hidden = true;
      lightboxTrack.innerHTML = '';
      // if the sheet was already closed underneath, release the lock now
      if (overlay.hidden) unlockBody();
    }, 220);
  }

  function findVariant() {
    if (!currentProduct) return null;
    return currentProduct.variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt === selectedOptions[i];
      });
    }) || null;
  }

  // Names that mark the "color" option (Hebrew + English)
  var COLOR_OPTION_NAMES = ['color', 'colour', 'צבע', 'צבעים'];
  function isColorOption(name) {
    var n = (name || '').toLowerCase().trim();
    return COLOR_OPTION_NAMES.some(function (c) { return n === c || n.indexOf(c) !== -1; });
  }

  var T = {
    add: 'הוספה לסל',
    choose: 'בחרי מידה',
    chooseOpt: 'בחרי',
    need: 'יש לבחור',
    soldout: 'אזל מהמלאי',
    unavailable: 'לא זמין',
    error: 'משהו השתבש, אפשר לנסות שוב',
    heart: 'הוספה לרשימת המשאלות',
    notify: 'עדכנו אותי כשחוזר למלאי'
  };
  /* STOQ (back in stock; it still uses its old Restock Rocket names). Checked when needed, since it can load after us. */
  function hasNotify() {
    return !!(window._RestockRocket && typeof window._RestockRocket.openModal === 'function');
  }
  function notifyOpen() {
    var w = document.querySelector('.restock-rocket-wrapper');
    return !!(w && w.getClientRects().length);
  }
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.8C9.12 18.59 3 14.64 3 9.79 3 6.94 5.28 4.9 8.04 4.9c1.8 0 3.24.88 3.96 2.15.72-1.27 2.16-2.15 3.96-2.15 2.76 0 5.04 2.04 5.04 4.89 0 4.85-6.12 8.8-9 11.01z"/></svg>';
  var currentExtra = {};
  var optionNames = [];
  var busy = false;
  // colour names are shown in Hebrew (the cc-desc template renders them through snippets/ts-color-name.liquid)
  var heName = {};
  function he(n) { return heName[String(n == null ? '' : n).toLowerCase()] || n || ''; }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function isSizeOption(name) {
    var n = (name || '').toLowerCase();
    return n.indexOf('מיד') !== -1 || n.indexOf('size') !== -1;
  }
  function optionLabel(name) {
    if (isColorOption(name)) return 'צבע';
    if (isSizeOption(name)) return 'מידה';
    return name;
  }
  function missingIndex() {
    for (var i = 0; i < selectedOptions.length; i++) if (selectedOptions[i] == null) return i;
    return -1;
  }
  function matchesSel(v, skip) {
    for (var i = 0; i < selectedOptions.length; i++) {
      if (i === skip || selectedOptions[i] == null) continue;
      if (v.options[i] !== selectedOptions[i]) return false;
    }
    return true;
  }
  function closestVariant() {
    if (!currentProduct) return null;
    var vs = currentProduct.variants, k;
    for (k = 0; k < vs.length; k++) if (vs[k].available && matchesSel(vs[k])) return vs[k];
    for (k = 0; k < vs.length; k++) if (matchesSel(vs[k])) return vs[k];
    return vs[0] || null;
  }

  function renderPrice(variant) {
    var priceEl = body.querySelector('.cc-qa-price');
    if (!priceEl || !variant) return;
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    /* the price, then (on sale) the old price crossed out; no % off anywhere on the site */
    var html = '<span class="cc-qa-price__' + (onSale ? 'sale' : 'now') + '">' + money(variant.price) + '</span>';
    if (onSale) html += '<s class="cc-qa-price__was">' + money(variant.compare_at_price) + '</s>';
    priceEl.innerHTML = html;
  }

  function updateState() {
    var addBtn = body.querySelector('.cc-qa-add');
    if (!addBtn || !currentProduct) return;
    var miss = missingIndex();
    var variant = miss < 0 ? findVariant() : null;
    renderPrice(variant || closestVariant());

    /* sizes that this colour doesn't have in stock are crossed out */
    body.querySelectorAll('.cc-qa-value[data-opt-index]').forEach(function (b) {
      var i = parseInt(b.dataset.optIndex, 10);
      var val = b.dataset.optValue;
      var avail = currentProduct.variants.some(function (v) { return v.options[i] === val && v.available && matchesSel(v, i); });
      b.classList.toggle('cc-qa-soldout', !avail);
      b.disabled = !avail && !hasNotify();
    });
    body.querySelectorAll('.cc-qa-swatch[data-opt-index][disabled]').forEach(function (b) {
      if (hasNotify()) b.disabled = false;
    });
    body.querySelectorAll('.cc-qa-option[data-index]').forEach(function (o) {
      var i = parseInt(o.dataset.index, 10);
      var out = o.querySelector('.cc-qa-option__val');
      if (out && !o.hasAttribute('data-linked')) out.textContent = isColorOption(optionNames[i]) ? he(selectedOptions[i]) : (selectedOptions[i] || '');
      if (selectedOptions[i] != null) o.classList.remove('cc-qa-need');
    });

    if (miss > -1) {
      addBtn.disabled = false;
      addBtn.dataset.state = 'choose';
      addBtn.textContent = isSizeOption(optionNames[miss]) ? T.choose : (T.chooseOpt + ' ' + optionLabel(optionNames[miss]));
    } else if (variant && variant.available) {
      addBtn.disabled = false;
      addBtn.dataset.state = 'add';
      addBtn.textContent = T.add;
    } else if (variant && hasNotify()) {
      addBtn.disabled = false;
      addBtn.dataset.state = 'notify';
      addBtn.textContent = T.notify;
    } else {
      addBtn.disabled = true;
      addBtn.dataset.state = variant ? 'soldout' : 'unavailable';
      addBtn.textContent = variant ? T.soldout : T.unavailable;
    }
    var heart = body.querySelector('.cc-qa-heart');
    if (heart) heart.setAttribute('data-v', (variant || closestVariant() || {}).id || '');
  }

  /* "choose a size": the size row answers (shake + red line) and comes into view */
  function nudge() {
    var miss = missingIndex();
    var o = body.querySelector('.cc-qa-option[data-index="' + miss + '"]');
    if (!o) return;
    o.classList.remove('cc-qa-need');
    void o.offsetWidth;
    o.classList.add('cc-qa-need');
    try { o.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
  }
  function showErr(msg) {
    var e = body.querySelector('.cc-qa-err');
    if (e) e.textContent = msg || '';
  }

  // Reduce a Shopify image URL to its bare filename (no host, query, size suffix)
  function imageKey(url) {
    if (!url) return '';
    var s = String(url).split('?')[0];
    s = s.split('/').pop();
    s = s.replace(/_(\d+)?x(\d+)?(@\dx)?(?=\.[a-z]+$)/i, '');
    return s;
  }

  // Find the gallery image index that belongs to a variant.
  function variantImageIndex(variant, product) {
    if (!variant) return -1;
    var fi = variant.featured_image;
    if (!fi) return -1;

    // featured_image may be an object {id, src, position, ...} or a URL string
    var fiSrc = (typeof fi === 'string') ? fi : fi.src;
    var fiPos = (typeof fi === 'object' && fi.position) ? fi.position : null;
    var fiId  = (typeof fi === 'object' && fi.id) ? fi.id : null;

    // 1) by position (1-based) → direct index into product.images
    if (fiPos && product.images && fiPos <= product.images.length) {
      // verify the filename matches to be safe
      if (imageKey(product.images[fiPos - 1]) === imageKey(fiSrc)) return fiPos - 1;
    }

    // 2) by filename match across product.images
    if (fiSrc && product.images) {
      var targetKey = imageKey(fiSrc);
      for (var i = 0; i < product.images.length; i++) {
        if (imageKey(product.images[i]) === targetKey) return i;
      }
    }

    // 3) by media id (if media array exists)
    if (fiId && product.media) {
      for (var m = 0; m < product.media.length; m++) {
        if (product.media[m].id === fiId && typeof product.media[m].position === 'number') {
          return product.media[m].position - 1;
        }
      }
    }
    return -1;
  }

  // Jump the gallery to the image associated with the selected variant
  function scrollGalleryToVariant(instant) {
    var variant = findVariant() || closestVariant();
    if (!variant || !currentProduct) return;
    var gallery = body.querySelector('.cc-qa-gallery');
    if (!gallery) return;

    var idx = variantImageIndex(variant, currentProduct);
    if (idx < 0) return;

    var imgs = gallery.querySelectorAll('img');
    var target = null;
    for (var i = 0; i < imgs.length; i++) {
      if (parseInt(imgs[i].getAttribute('data-index'), 10) === idx) { target = imgs[i]; break; }
    }
    if (!target) return;

    // desktop gallery scrolls vertically, mobile scrolls horizontally
    var behavior = instant ? 'auto' : 'smooth';
    if (isDesktop()) {
      gallery.scrollTo({ top: target.offsetTop - gallery.offsetTop, behavior: behavior });
    } else {
      gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: behavior });
    }
  }

  function selectValue(optionIndex, value, btn) {
    if (isNaN(optionIndex) || value == null) return; // guard own-color swatch
    selectedOptions[optionIndex] = value;
    var group = btn.closest('.cc-qa-option__values');
    // clear selection from BOTH size buttons and color swatches in this group
    group.querySelectorAll('.cc-qa-value, .cc-qa-swatch').forEach(function (b) {
      b.classList.remove('cc-qa-selected');
    });
    btn.classList.add('cc-qa-selected');
    updateState();
    scrollGalleryToVariant();
  }

  // photos the card already showed (same file), reused so they appear at once instead of loading again
  var cardImgs = {};

  // photos fade in as each one arrives (never a blank square popping into a photo)
  function wireGalleryFade() {
    body.querySelectorAll('.cc-qa-gallery img').forEach(function (img) {
      if (img.classList.contains('is-in')) return;
      var show = function () { img.classList.add('is-in'); };
      if (img.complete && img.naturalWidth) show();
      else { img.addEventListener('load', show); img.addEventListener('error', show); }
    });
  }

  function render(product, extra) {
    currentProduct = product;
    currentExtra = extra || {};
    busy = false;
    body.classList.remove('cc-qa-wait');
    // the colour comes chosen (first in stock); the size is always her choice, as on the product page
    var firstAvail = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    selectedOptions = firstAvail ? firstAvail.options.slice() : [];
    optionNames = product.options.map(function (o) { return (typeof o === 'string') ? o : o.name; });
    optionNames.forEach(function (n, i) {
      if (isColorOption(n)) return;
      var vals = {};
      product.variants.forEach(function (v) { vals[v.options[i]] = true; });
      if (Object.keys(vals).length > 1) selectedOptions[i] = null;
    });
    var sw = Array.isArray(currentExtra.sw) ? currentExtra.sw : [];
    heName = {};
    sw.forEach(function (s) { if (s && s.n) heName[s.n.toLowerCase()] = s.t || s.n; });
    /* colours are photos, or (when any colour has no photo) their names, like the product page; never colour dots */
    var swAllImg = sw.length > 0 && sw.every(function (s) { return !s || s.i; });
    var swCombined = sw.some(function (s) { return s && s.h && s.h !== product.handle; });
    // "מכנס מרבל | חום": the name on its own line, the colour next to "צבע" (as on the product page)
    var tParts = String(product.title || '').split(' | ');
    var tMain = tParts[0];
    var tColor = tParts.length > 1 ? tParts[tParts.length - 1] : '';

    var html = '';
    html += '<div class="cc-qa-layout">';

    // --- Media column (gallery) ---
    html += '<div class="cc-qa-media">';
    if (product.images && product.images.length) {
      html += '<div class="cc-qa-gallery">';
      var gw = galleryWidth();
      product.images.forEach(function (src, idx) {
        var known = cardImgs[imageKey(src)];
        var bigSrc = known || sizedImage(src, gw);
        html += '<img src="' + bigSrc + '" data-full="' + src + '" data-index="' + idx + '" alt="' + esc(product.title) + '"' + (known || ready[bigSrc] ? ' class="is-in"' : '') + (idx > 2 ? ' loading="lazy"' : '') + '>';
      });
      html += '</div>';
    }
    html += '</div>'; // .cc-qa-media

    // --- Info column ---
    html += '<div class="cc-qa-info">';
    html += '<div class="cc-qa-titlerow"><h5 class="cc-qa-title">' + esc(tMain) + (tColor ? '<span class="visually-hidden"> | ' + esc(tColor) + '</span>' : '') + '</h5>';
    if (window.TSWishlist) {
      html += '<button type="button" class="ts-wl-pdp cc-qa-heart" data-h="' + esc(product.handle) + '" data-v="' + (firstAvail ? firstAvail.id : '') + '" aria-label="' + T.heart + '" aria-pressed="false">' + HEART + '</button>';
    }
    html += '</div>';
    html += '<div class="cc-qa-price" role="status"></div>';

    var hasRealOptions = !(optionNames.length === 1 && optionNames[0].toLowerCase() === 'title');

    if (hasRealOptions) {
      html += '<div class="cc-qa-options">';
      optionNames.forEach(function (optName, optIndex) {
        var colorOpt = isColorOption(optName);
        var label = optionLabel(optName);
        var linked = colorOpt && (swCombined || currentSiblings.length > 0);
        var shownVal = colorOpt ? (he(selectedOptions[optIndex]) || (linked && tColor) || '') : '';
        html += '<div class="cc-qa-option" data-index="' + optIndex + '"' + (linked ? ' data-linked' : '') + '>';
        html += '<p class="cc-qa-option__label"><span class="cc-qa-option__name">' + esc(label) + '</span><span class="cc-qa-option__val">' + esc(shownVal) + '</span><span class="cc-qa-option__need">' + T.need + ' ' + esc(label) + '</span></p>';
        // how many values the row holds (sizes): five or six share one row, like the product page
        var nVals = colorOpt ? 0 : product.variants.reduce(function (acc, v) { var x = v.options[optIndex]; if (acc.indexOf(x) < 0) acc.push(x); return acc; }, []).length;
        html += '<div class="cc-qa-option__values' + (colorOpt ? ' cc-qa-option__values--swatch' : '') + '"' + (nVals ? ' data-n="' + nVals + '"' : '') + '>';

        var seen = {};
        var isCombined = colorOpt && currentSiblings.length > 0;

        if (colorOpt && sw.length) {
          // colour photos, in the same fixed order as the product page
          sw.forEach(function (s) {
            if (!s || !s.n) return;
            var key = s.n.toLowerCase();
            if (seen[key]) return;
            seen[key] = true;
            var img = swAllImg ? '<img src="' + esc(s.i) + '" alt="" width="46" height="69"><span class="visually-hidden">' + esc(he(s.n)) + '</span>' : esc(he(s.n));
            var cls = swAllImg ? 'cc-qa-swatch cc-qa-swatch--img' : 'cc-qa-value cc-qa-value--color';
            var title = ' title="' + esc(he(s.n)) + '" data-swatch="' + esc(key) + '"';
            if (swCombined && s.h && s.h !== product.handle) {
              html += '<button type="button" class="' + cls + ' cc-qa-swatch--sibling' + (s.a === false ? ' cc-qa-soldout' : '') + '" data-sibling-handle="' + esc(s.h) + '"' + title + '>' + img + '</button>';
            } else if (swCombined) {
              html += '<button type="button" class="' + cls + ' cc-qa-selected"' + title + ' aria-current="true">' + img + '</button>';
            } else {
              var anyAvail = product.variants.some(function (vv) { return vv.options[optIndex] === s.n && vv.available; });
              var isSel = selectedOptions[optIndex] === s.n;
              html += '<button type="button" class="' + cls + (isSel ? ' cc-qa-selected' : '') + (anyAvail ? '' : ' cc-qa-soldout') + '" data-opt-index="' + optIndex + '" data-opt-value="' + esc(s.n) + '"' + title + (anyAvail ? '' : ' disabled') + '>' + img + '</button>';
            }
          });
        } else if (isCombined) {
          // Combined listing: this product represents ONE color.
          // Its own color renders as selected (not a re-selectable swatch),
          // and every sibling color is a clickable swatch that LOADS that product.
          var ownColors = [];
          product.variants.forEach(function (v) {
            var val = v.options[optIndex];
            if (val && ownColors.indexOf(val) === -1) ownColors.push(val);
          });

          // Stable order: walk the sibling list (same order on every switch);
          // the current color renders as selected IN ITS OWN SLOT.
          var ownKeys = {};
          ownColors.forEach(function (val) { ownKeys[val.toLowerCase()] = val; });

          function ownSwatch(val) {
            var safeVal = val.replace(/"/g, '&quot;');
            return '<button type="button" class="cc-qa-value cc-qa-value--color cc-qa-selected"' +
              ' data-swatch="' + val.toLowerCase() + '"' +
              ' title="' + esc(he(val)) + '" aria-current="true">' + esc(he(val)) + '</button>';
          }

          var ordered = '';
          currentSiblings.forEach(function (sib) {
            if (sib.option && isColorOption(sib.option) === false) return;
            var key = (sib.name || '').toLowerCase();
            if (!key || seen[key]) return;
            seen[key] = true;
            if (ownKeys[key] !== undefined) { ordered += ownSwatch(ownKeys[key]); return; }
            var safeName = sib.name.replace(/"/g, '&quot;');
            var sibSoldOut = (sib.available === false);
            ordered += '<button type="button" class="cc-qa-value cc-qa-value--color cc-qa-swatch--sibling' +
              (sibSoldOut ? ' cc-qa-soldout' : '') +
              '" data-swatch="' + key + '"' +
              ' data-sibling-handle="' + sib.handle + '"' +
              ' title="' + esc(he(sib.name)) + '">' + esc(he(sib.name)) + '</button>';
          });
          // Own color missing from the sibling list (edge case): put it first.
          var lead = '';
          ownColors.forEach(function (val) {
            var key = val.toLowerCase();
            if (seen[key]) return;
            seen[key] = true;
            lead += ownSwatch(val);
          });
          html += lead + ordered;
        } else {
          // Standard single product: each option value is selectable
          product.variants.forEach(function (v) {
            var val = v.options[optIndex];
            if (seen[val]) return;
            seen[val] = true;
            var anyAvail = product.variants.some(function (vv) {
              return vv.options[optIndex] === val && vv.available;
            });
            var isSel = selectedOptions[optIndex] === val;
            var safeVal = val.replace(/"/g, '&quot;');

            if (colorOpt) {
              html += '<button type="button" class="cc-qa-value cc-qa-value--color' +
                (isSel ? ' cc-qa-selected' : '') +
                (anyAvail ? '' : ' cc-qa-soldout') +
                '" data-swatch="' + safeVal.toLowerCase() + '"' +
                ' data-opt-index="' + optIndex + '" data-opt-value="' + safeVal + '"' +
                ' title="' + esc(he(val)) + '"' +
                (anyAvail ? '' : ' disabled') + '>' + esc(he(val)) + '</button>';
            } else {
              html += '<button type="button" class="cc-qa-value' +
                (isSel ? ' cc-qa-selected' : '') +
                (anyAvail ? '' : ' cc-qa-soldout') +
                '" data-opt-index="' + optIndex + '" data-opt-value="' + safeVal + '"' +
                (anyAvail ? '' : ' disabled') + '>' + val + '</button>';
            }
          });
        }

        html += '</div></div>';
      });
      html += '</div>'; // .cc-qa-options
    }

    // Product description — open, no title, directly under the options.
    // Taken from the custom.model_info metafield (rich text), NOT product.description.
    var descHtml = currentExtra.desc || '';
    if (descHtml && descHtml.trim()) {
      html += '<div class="cc-qa-desc">' + descHtml + '</div>';
    }

    html += '</div>'; // .cc-qa-info
    html += '</div>'; // .cc-qa-layout

    // Call-to-action footer — sibling of the layout, OUTSIDE the scroll area,
    // so content can never peek beneath it.
    html += '<div class="cc-qa-cta">';
    html += '<button type="button" class="cc-qa-add"></button>';
    html += '<p class="cc-qa-err" role="alert"></p>';
    if (product.url) {
      html += '<a class="cc-qa-view-full" href="' + product.url + '">לצפייה בפרטים המלאים</a>';
    }
    html += '</div>'; // .cc-qa-cta

    body.innerHTML = html;
    wireGalleryFade();

    // wire sibling swatches (combined listing) → load that product
    body.querySelectorAll('.cc-qa-swatch--sibling').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var h = btn.dataset.siblingHandle;
        if (h) loadProduct(h);
      });
    });

    // wire normal option + own-color swatch buttons (skip the non-selectable
    // own-color swatch in combined listings, which has no data-opt-index)
    // (a size that is out in one colour can come back in another, so every button is wired)
    body.querySelectorAll('.cc-qa-value[data-opt-index], .cc-qa-swatch[data-opt-index]:not(.cc-qa-swatch--sibling)').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectValue(parseInt(btn.dataset.optIndex, 10), btn.dataset.optValue, btn);
      });
    });

    // wire add button
    body.querySelector('.cc-qa-add').addEventListener('click', addToCart);

    updateState();
    scrollGalleryToVariant(true);
    fitSheet();
    if (window.TSWishlist && typeof TSWishlist.refresh === 'function') { try { TSWishlist.refresh(); } catch (e) {} }
  }

  /* the first frame of the sheet, drawn from the card she tapped (photo, name, price) with the same layout as the
     full sheet, so the sheet rises at once and the rest fills in place without moving */
  function cardOf(btn) {
    return btn ? btn.closest('product-block, .product-block, .pb, [data-handle]') : null;
  }
  function collectCardImgs(card) {
    cardImgs = {};
    var tiles = '';
    var count = 0;
    if (card) {
      card.querySelectorAll('.product-block__image img, img').forEach(function (img) {
        if (count >= 3) return;
        var src = img.currentSrc || img.src;
        if (!src || src.indexOf('data:') === 0) return;
        var key = imageKey(src);
        if (!key || cardImgs[key]) return;
        if (!(img.complete && img.naturalWidth)) return; // only photos already on screen
        cardImgs[key] = src;
        tiles += '<img src="' + esc(src) + '" alt="" class="is-in">';
        count++;
      });
    }
    return { tiles: tiles, count: count };
  }
  function renderSkeleton(btn, handleName) {
    var card = cardOf(btn);
    var got = collectCardImgs(card);
    var tiles = got.tiles;
    var count = got.count;
    for (; count < 3; count++) tiles += '<i class="cc-qa-ph cc-qa-ph--img"></i>';

    var name = '';
    var price = '';
    var url = '';
    if (card) {
      var t = card.querySelector('.product-block__title, .pb__title, [class*="title"]');
      if (t) name = t.textContent.trim();
      var p = card.querySelector('.price__current, .product-price, [class*="price"]');
      if (p) price = p.textContent.replace(/\s+/g, ' ').trim();
      var a = card.querySelector('a[href*="/products/"]');
      if (a) url = a.getAttribute('href');
    }
    if (!name && btn) name = (btn.getAttribute('aria-label') || '').split(':').slice(1).join(':').trim();
    name = name.split(' | ')[0];
    if (!url && handleName) url = '/products/' + handleName;

    var chips = '';
    for (var i = 0; i < 4; i++) chips += '<i class="cc-qa-value cc-qa-ph"></i>';

    var html = '<div class="cc-qa-layout cc-qa-skel" aria-busy="true">';
    html += '<div class="cc-qa-media"><div class="cc-qa-gallery">' + tiles + '</div></div>';
    html += '<div class="cc-qa-info">';
    html += '<div class="cc-qa-titlerow"><h5 class="cc-qa-title">' + (name ? esc(name) : '<i class="cc-qa-ph cc-qa-ph--line"></i>') + '</h5></div>';
    html += '<div class="cc-qa-price">' + (price ? '<span class="cc-qa-price__now">' + esc(price) + '</span>' : '<i class="cc-qa-ph cc-qa-ph--short"></i>') + '</div>';
    html += '<div class="cc-qa-options">';
    html += '<div class="cc-qa-option"><p class="cc-qa-option__label"><span class="cc-qa-option__name">צבע</span></p><div class="cc-qa-option__values cc-qa-option__values--swatch"><i class="cc-qa-ph cc-qa-ph--swatch"></i></div></div>';
    html += '<div class="cc-qa-option"><p class="cc-qa-option__label"><span class="cc-qa-option__name">מידה</span></p><div class="cc-qa-option__values" data-n="4">' + chips + '</div></div>';
    html += '</div>';
    html += '</div></div>';
    html += '<div class="cc-qa-cta"><button type="button" class="cc-qa-add cc-qa-add--wait" tabindex="-1" aria-hidden="true">' + T.add + '</button><p class="cc-qa-err" role="alert"></p>';
    if (url) html += '<a class="cc-qa-view-full" href="' + esc(url) + '">לצפייה בפרטים המלאים</a>';
    html += '</div>';
    body.innerHTML = html;
    fitSheet();
  }

  /* content changes while the sheet is up (skeleton → product, another colour): the sheet glides to its new
     height instead of jumping, and the new parts fade in */
  function swapIn(draw) {
    var open = overlay.classList.contains('cc-qa-open');
    var h0 = open ? sheet.getBoundingClientRect().height : 0;
    clearTimeout(enterTimer);
    body.classList.remove('cc-qa-enter'); // new parts never replay the opening animation
    // photos already showing stay the very same picture (no blink while the browser redraws them)
    var shown = {};
    body.querySelectorAll('.cc-qa-gallery img.is-in').forEach(function (img) { shown[img.getAttribute('src')] = img; });
    draw();
    body.querySelectorAll('.cc-qa-gallery img.is-in').forEach(function (img) {
      var old = shown[img.getAttribute('src')];
      if (!old || old === img) return;
      ['data-index', 'data-full', 'alt', 'loading'].forEach(function (a) {
        if (img.hasAttribute(a)) old.setAttribute(a, img.getAttribute(a)); else old.removeAttribute(a);
      });
      old.className = img.className;
      img.replaceWith(old);
      delete shown[old.getAttribute('src')];
    });
    if (!open || reducedMotion()) return;
    var h1 = sheet.getBoundingClientRect().height;
    body.classList.remove('cc-qa-swap');
    void body.offsetWidth;
    body.classList.add('cc-qa-swap');
    if (Math.abs(h1 - h0) > 2 && sheet.animate) {
      try {
        sheet.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' });
      } catch (e) {}
    }
  }

  /* phones: the sheet is exactly as tall as it needs to be for photos, name, price, colours, sizes and the button
     to show in full, with the start of the description peeking under them (it never covers more than it must) */
  /* phones: the sheet has one fixed height (CSS) for every product, the skeleton included, so it never grows or
     shrinks once it is up; anything longer scrolls inside it */
  function fitSheet() {
    sheet.style.maxHeight = '';
  }
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    // iPhone Safari fires resize when its toolbar shows or hides; only a real size change refits the sheet
    if (window.innerWidth === lastW && !isDesktop()) return;
    lastW = window.innerWidth;
    if (!overlay.hidden && currentProduct && body.querySelector('.cc-qa-layout')) fitSheet();
  });

  /* add to bag — the same request as the product page: warehouse line property, header + drawer
     refreshed from the server response, then the drawer opens */
  function addToCart() {
    var addBtn = body.querySelector('.cc-qa-add');
    if (!addBtn || busy) return;
    if (addBtn.dataset.state === 'choose') { nudge(); return; }
    if (addBtn.dataset.state === 'notify') { openNotify(); return; }
    var variant = findVariant();
    if (!variant || !variant.available) return;
    busy = true;
    showErr('');
    addBtn.classList.add('is-loading');
    addBtn.setAttribute('aria-busy', 'true');

    var fd = new FormData();
    fd.append('id', variant.id);
    fd.append('quantity', 1);
    if (currentExtra.wh) fd.append('properties[_מיקום במחסן אתר]', currentExtra.wh);
    var secs = ['page-header', 'cart-drawer'].map(function (q) { return document.querySelector(q); }).filter(function (el) { return el && el.dataset && el.dataset.sectionId; });
    if (secs.length) {
      fd.append('sections', secs.map(function (el) { return el.dataset.sectionId; }).join(','));
      fd.append('sections_url', window.location.pathname);
    }
    var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';

    fetch(url, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      /* a busy store can answer with a bot check page (403/429 HTML) instead of JSON: that is a plain "try again", never raw parser text */
      .then(function (res) { return res.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e) {} return { ok: res.ok, j: j }; }); })
      .then(function (r) {
        var j = r.j || {};
        if (!r.j || !r.ok || j.status) {
          var msg = typeof j.description === 'string' ? j.description : j.message;
          var err = new Error(msg || '');
          err.fromStore = true;
          throw err;
        }
        var updated = false;
        if (j.sections) {
          secs.forEach(function (el) {
            var html = j.sections[el.dataset.sectionId];
            if (html && typeof el.updateFromCartChange === 'function') { el.updateFromCartChange(html); updated = true; }
          });
        }
        if (updated) {
          var drawer = document.querySelector('.js-cart-drawer');
          if (!openDrawerElement(drawer)) window.location.href = '/cart';
        } else {
          refreshAndOpenCart();
        }
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: variant.id } }));
        // stock changed: the next quick add of this product asks the store again
        if (currentProduct) delete dataCache[currentProduct.handle];
        busy = false;
        closeSheet();
      })
      .catch(function (err) {
        busy = false;
        addBtn.classList.remove('is-loading');
        addBtn.removeAttribute('aria-busy');
        showErr(err && err.fromStore && err.message ? err.message : T.error);
      });
  }

  /* sold-out size: STOQ's own form opens on top of the sheet, for this exact colour and size */
  function openNotify() {
    var v = findVariant();
    if (!v || !currentProduct || !hasNotify()) return;
    showErr('');
    try { window._RestockRocket.openModal(currentProduct, String(v.id)); }
    catch (e) { showErr(T.error); }
  }

  // Clean Canvas / Symmetry: the cart drawer is a <cart-form> inside <cart-drawer>
  // that updates by merging freshly-rendered HTML. We fetch the cart-drawer
  // section, swap in the new markup, then open the drawer.
  function refreshAndOpenCart() {
    var cartDrawer = document.querySelector('cart-drawer, .js-cart-drawer');

    // 1) Try the theme's own public API / events first (most correct)
    // Clean Canvas dispatches 'on:cart:add' & re-renders via PubSub; opening
    // the drawer triggers its refresh in most builds.
    var opened = openDrawerElement(cartDrawer);

    // 2) Always fetch fresh cart-drawer HTML and merge it in, so contents are current
    var sectionId = cartDrawer ? cartDrawer.getAttribute('data-section-id') : null;
    var url = '?sections=cart-drawer';
    // Prefer the Section Rendering API with the real section id when available
    if (sectionId) {
      url = '/?section_id=' + encodeURIComponent(sectionId);
    }

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var newDoc = new DOMParser().parseFromString(text, 'text/html');
        var newForm = newDoc.querySelector('cart-form');
        var curForm = document.querySelector('cart-form');
        if (newForm && curForm) {
          curForm.innerHTML = newForm.innerHTML;
          activateImages(curForm);
        }
        // update header cart counts
        var newCount = newDoc.querySelector('.cart-drawer__title-count');
        if (newCount) {
          document.querySelectorAll('.cart-drawer__title-count').forEach(function (el) {
            el.textContent = newCount.textContent;
          });
        }
        // make sure content/footer are shown (not in empty state)
        var content = document.querySelector('.cart-drawer__content');
        var footer = document.querySelector('.cart-drawer__footer');
        if (content) content.classList.remove('cart-drawer__content--hidden');
        if (footer) footer.classList.remove('cart-drawer__footer--hidden');

        if (!opened) openDrawerElement(document.querySelector('cart-drawer, .js-cart-drawer'));

        // also bump the header bag counter via cart.js
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count], .cart-link__count, .js-cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        }).catch(function () {});
      })
      .catch(function () {
        // fallback: just navigate to cart page
        window.location.href = '/cart';
      });
  }

  function openDrawerElement(drawer) {
    if (!drawer) return false;
    // Clean Canvas drawers expose .open() in most versions
    if (typeof drawer.open === 'function') {
      try { drawer.open(); return true; } catch (e) {}
    }
    // Fallback: replicate the open state the theme uses
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-visible', 'drawer--is-open', 'active');
    document.documentElement.classList.add('drawer-open');
    document.body.classList.add('drawer-open');
    // click a cart toggle if one exists (lets the theme handle focus-trap etc.)
    var toggle = document.querySelector('[data-drawer-target="cart-drawer"], .js-cart-drawer-toggle, [aria-controls="cart-drawer"]');
    if (toggle) { try { toggle.click(); return true; } catch (e) {} }
    return true;
  }

  // The theme renders cart images with loading="manual" (or lazy), keeping the
  // real source in data-src / data-srcset / data-bgset until its own JS swaps it in.
  // After we merge fresh HTML, that JS doesn't run, so force the images to load.
  function activateImages(root) {
    if (!root) return;
    root.querySelectorAll('img').forEach(function (img) {
      // Clean Canvas "manual" loading keeps the real source in
      // data-manual-src / data-manual-srcset until its JS swaps it in.
      if (img.dataset.manualSrc) {
        img.src = img.dataset.manualSrc;
      }
      if (img.dataset.manualSrcset) {
        img.srcset = img.dataset.manualSrcset;
      }
      // also support the standard lazy attributes as a fallback
      if (img.dataset.src) {
        img.src = img.dataset.src;
      }
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
      }
      img.classList.add('lazyloaded');
      img.classList.remove('lazyload');
      if (img.getAttribute('loading') === 'manual') {
        img.setAttribute('loading', 'eager');
      }
      if (!img.getAttribute('src') && img.getAttribute('srcset')) {
        img.setAttribute('src', img.getAttribute('srcset').split(' ')[0]);
      }
    });
    // Also activate <source> elements inside <picture>
    root.querySelectorAll('source[data-manual-srcset], source[data-srcset]').forEach(function (s) {
      if (s.dataset.manualSrcset) s.srcset = s.dataset.manualSrcset;
      else if (s.dataset.srcset) s.srcset = s.dataset.srcset;
    });
    // Nudge any global lazy-loader (e.g. lazysizes) if present
    if (window.lazySizes && typeof window.lazySizes.loader === 'object') {
      try { window.lazySizes.loader.checkElems(); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('lazyloaded', { bubbles: true }));
  }

  // Shared loader: the product JSON and the small extras (description, colour photos, warehouse line)
  // come in together. One request per product per minute: the touch on the + already starts it,
  // and opening the same product again is instant.
  var lastHandle = null;
  var dataCache = {};
  var CACHE_MS = 60000;

  function getData(handle) {
    var c = dataCache[handle];
    if (c && Date.now() - c.t < CACHE_MS) return c;
    var productReq = fetchWithTimeout('/products/' + handle + '.js', 9000)
      .then(function (res) {
        if (!res.ok) throw new Error('bad status');
        return res.json();
      });
    c = { t: Date.now(), r: null };
    c.p = Promise.all([productReq, fetchExtra(handle)]);
    c.p.then(function (r) {
      c.r = r;
      // warm the first photos while the sheet is still rising
      var gw = galleryWidth();
      (r[0].images || []).slice(0, 3).forEach(function (src) { preload(sizedImage(src, gw)); });
    }, function () {
      if (dataCache[handle] === c) delete dataCache[handle];
    });
    dataCache[handle] = c;
    return c;
  }

  // photos that have fully arrived (decoded), so they can be shown at once with no fade from white
  var ready = {};
  var pending = {};
  function preload(url) {
    if (!url) return Promise.resolve();
    if (ready[url]) return Promise.resolve();
    if (pending[url]) return pending[url];
    var im = new Image();
    im.src = url;
    var p = (im.decode ? im.decode() : new Promise(function (res, rej) { im.onload = res; im.onerror = rej; }))
      .then(function () { ready[url] = true; }, function () {});
    pending[url] = p;
    return p;
  }
  // wait (a little) for the first photos and colour photos, so the sheet changes once, complete
  function photosFor(r, ms) {
    var gw = galleryWidth();
    var urls = (r[0].images || []).slice(0, 3).map(function (src) { return cardImgs[imageKey(src)] ? null : sizedImage(src, gw); });
    ((r[1] && r[1].sw) || []).forEach(function (s) { if (s && s.i) urls.push(s.i); });
    var all = Promise.all(urls.filter(Boolean).map(preload));
    return Promise.race([all, new Promise(function (res) { setTimeout(res, ms); })]);
  }

  function loadProduct(handle, fromBtn) {
    lastHandle = handle;
    var c = getData(handle);
    if (fromBtn) collectCardImgs(cardOf(fromBtn));
    if (c.r) {
      if (fromBtn) render(c.r[0], c.r[1]);
      else swapIn(function () { render(c.r[0], c.r[1]); });
      return c.p;
    }
    if (fromBtn) renderSkeleton(fromBtn, handle);
    else body.classList.add('cc-qa-wait'); // another colour: the current one dims until the new one is in
    return c.p
      .then(function (r) {
        return photosFor(r, 700).then(function () { return r; });
      })
      .then(function (r) {
        if (lastHandle !== handle || overlay.hidden) return; // she switched or closed meanwhile
        swapIn(function () { render(r[0], r[1]); });
      })
      .catch(function () {
        if (lastHandle !== handle || overlay.hidden) return;
        body.classList.remove('cc-qa-wait');
        swapIn(showLoadError);
      });
  }


  // Description (custom.model_info), colour photos and the warehouse line, served by the tiny
  // template templates/product.cc-desc.liquid. Never blocks the sheet: a failure means "no extras".
  var extraCache = {};
  function between(txt, name) {
    var S = '<!--CC-' + name + '-START-->', E = '<!--CC-' + name + '-END-->';
    var i = txt.indexOf(S), j = txt.indexOf(E);
    return (i !== -1 && j > i) ? txt.slice(i + S.length, j).trim() : '';
  }
  function fetchExtra(handle) {
    if (extraCache[handle]) return Promise.resolve(extraCache[handle]);
    return fetchWithTimeout('/products/' + handle + '?view=cc-desc', 5000)
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (txt) {
        var out = { desc: between(txt, 'DESC') };
        try {
          var d = JSON.parse(between(txt, 'DATA') || '{}');
          out.sw = d.sw || [];
          out.wh = d.wh || '';
        } catch (e) {}
        extraCache[handle] = out;
        // the colour photos are tiny: fetch them now so the colour row is complete when it appears
        (out.sw || []).forEach(function (s) { if (s && s.i) { var im = new Image(); im.src = s.i; } });
        return out;
      })
      .catch(function () { return {}; });
  }

  // fetch that rejects after `ms` so a hung connection never spins forever
  function fetchWithTimeout(url, ms) {
    return new Promise(function (resolve, reject) {
      var done = false;
      var timer = setTimeout(function () {
        if (!done) { done = true; reject(new Error('timeout')); }
      }, ms || 9000);
      fetch(url, { cache: 'no-store' }).then(function (res) {
        if (done) return;
        done = true; clearTimeout(timer); resolve(res);
      }).catch(function (err) {
        if (done) return;
        done = true; clearTimeout(timer); reject(err);
      });
    });
  }

  function showLoadError() {
    body.innerHTML =
      '<div class="cc-qa-loading">' +
      '<div style="margin-bottom:14px;color:#1a1a1a;">לא הצלחנו לטעון, בדוק את החיבור</div>' +
      '<button type="button" class="cc-qa-retry" data-cc-qa-retry>נסה שוב</button>' +
      '</div>';
    sheet.style.maxHeight = '';
    var retry = body.querySelector('[data-cc-qa-retry]');
    if (retry) retry.addEventListener('click', function () {
      if (lastHandle) loadProduct(lastHandle);
    });
  }

  // gallery photo → fullscreen viewer at that photo
  body.addEventListener('click', function (e) {
    var img = e.target.closest('.cc-qa-gallery img[data-index]');
    if (!img || !currentProduct) return;
    openLightbox(currentProduct.images || [], parseInt(img.getAttribute('data-index'), 10) || 0);
  });

  // the moment a finger (or mouse) lands on the +, the product starts loading, before the tap even ends
  function prefetchFrom(e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cc-quick-add]') : null;
    if (btn && btn.dataset.productHandle) getData(btn.dataset.productHandle);
  }
  document.addEventListener('pointerdown', prefetchFrom, { passive: true });
  document.addEventListener('touchstart', prefetchFrom, { passive: true });
  var hoverTimer = null;
  document.addEventListener('mouseover', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cc-quick-add]');
    clearTimeout(hoverTimer);
    if (btn) hoverTimer = setTimeout(function () { prefetchFrom(e); }, 90);
  });

  // a little pop on the + so the tap feels answered
  function popButton(btn) {
    if (reducedMotion()) return;
    btn.classList.remove('cc-qa-pop');
    void btn.offsetWidth;
    btn.classList.add('cc-qa-pop');
    setTimeout(function () { btn.classList.remove('cc-qa-pop'); }, 650);
  }

  // Open handler — delegated so it works for all product cards
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var handle = btn.dataset.productHandle;
    if (!handle) return;

    currentSiblings = [];
    if (btn.dataset.ccSiblings) {
      try {
        var parsed = JSON.parse(btn.dataset.ccSiblings);
        if (Array.isArray(parsed)) currentSiblings = parsed;
      } catch (err) { currentSiblings = []; }
    }

    popButton(btn);
    currentProduct = null;
    openSheet();
    loadProduct(handle, btn);
    revealSheet();
  });

  /* The sheet's stylesheet loads without holding up the page (media="print", switched to "all" when it loads).
     Safari can skip that switch when the page comes back from its cache, which leaves the sheet unstyled at the
     very bottom of the page, so the button seems to do nothing. Switch it on ourselves, every time. */
  function ensureStyles() {
    var l = document.querySelector('link[href*="cc-quick-add.css"]');
    if (l && l.media !== 'all') l.media = 'all';
  }
  ensureStyles();

  /* back to the collection from a product (the browser restores the page as it was): no sheet left open over it,
     the page unlocked at the exact place she left it, ready for the next quick add */
  function closeNow() {
    clearTimeout(closeTimer);
    if (lightbox && !lightbox.hidden) {
      lightbox.classList.remove('cc-qa-lightbox--open');
      lightbox.hidden = true;
      if (lightboxTrack) lightboxTrack.innerHTML = '';
    }
    var wasOpen = !overlay.hidden;
    overlay.classList.remove('cc-qa-open');
    overlay.hidden = true;
    body.innerHTML = '';
    body.classList.remove('cc-qa-enter', 'cc-qa-swap', 'cc-qa-wait');
    busy = false;
    lastHandle = null;
    sheet.style.transition = '';
    sheet.style.transform = '';
    sheet.style.maxHeight = '';
    overlay.style.transition = '';
    overlay.style.opacity = '';
    if (wasOpen || locked) unlockBody();
  }
  window.addEventListener('pageshow', function (e) {
    ensureStyles();
    if (e.persisted) closeNow();
  });

  // Close handlers
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay || e.target.closest('[data-cc-qa-close]')) {
      closeSheet();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (notifyOpen()) return;
    if (lightbox && !lightbox.hidden) { closeLightbox(); return; }
    if (!overlay.hidden) closeSheet();
  });

  // Lightbox close
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target.closest('[data-cc-qa-lightbox-close]')) closeLightbox();
    });
  }

  // --- Swipe-to-dismiss (drag only from the handle) ---
  // The drag must START on the handle bar, so swiping/scrolling anywhere
  // else in the sheet never moves or closes it. Horizontal swipes are
  // ignored so left/right gestures don't dismiss the sheet.
  var dragStartX = 0;
  var dragStartY = 0;
  var dragDelta = 0;
  var dragging = false;
  var decided = false;       // have we decided this is a vertical drag?
  var isVertical = false;
  var lastY = 0;
  var lastT = 0;
  var velocity = 0;
  var rafId = null;
  var SNAP = 'transform 0.36s cubic-bezier(0.22, 1, 0.36, 1)';

  function applyDrag() {
    rafId = null;
    sheet.style.transform = 'translateY(' + dragDelta + 'px)';
    overlay.style.opacity = Math.max(0.2, 1 - dragDelta / 600);
  }

  if (handle) {
    handle.addEventListener('touchstart', function (e) {
      dragStartX = e.touches[0].clientX;
      dragStartY = e.touches[0].clientY;
      lastY = dragStartY;
      lastT = Date.now();
      velocity = 0;
      dragDelta = 0;
      dragging = true;
      decided = false;
      isVertical = false;
      sheet.style.transition = 'none';
    }, { passive: true });

    handle.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var x = e.touches[0].clientX;
      var y = e.touches[0].clientY;
      var dx = x - dragStartX;
      var dy = y - dragStartY;

      // Decide direction once: if mostly horizontal, abort the drag
      if (!decided) {
        if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
          decided = true;
          isVertical = Math.abs(dy) > Math.abs(dx);
          if (!isVertical) { dragging = false; return; }
        } else {
          return;
        }
      }
      if (!isVertical) return;

      dragDelta = dy < 0 ? 0 : dy; // downward only

      var now = Date.now();
      var dt = now - lastT;
      if (dt > 0) velocity = (y - lastY) / dt;
      lastY = y;
      lastT = now;

      if (e.cancelable) e.preventDefault(); // stop page scroll while dragging
      if (rafId == null) rafId = requestAnimationFrame(applyDrag);
    }, { passive: false });

    handle.addEventListener('touchend', endDrag);
    handle.addEventListener('touchcancel', endDrag);
  }

  function endDrag() {
    if (!dragging) return;
    dragging = false;
    if (rafId != null) { cancelAnimationFrame(rafId); rafId = null; }
    if (!isVertical) { resetSheet(); return; }

    var shouldClose = dragDelta > 100 || velocity > 0.55;
    if (shouldClose) {
      sheet.style.transition = SNAP;
      sheet.style.transform = 'translateY(100%)';
      overlay.style.transition = 'opacity 0.3s ease';
      overlay.style.opacity = '0';
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        closeSheet();
        overlay.style.transition = '';
      }, 300);
    } else {
      resetSheet();
    }
  }

  function resetSheet() {
    sheet.style.transition = SNAP;
    sheet.style.transform = 'translateY(0)';
    overlay.style.opacity = '';
    setTimeout(function () {
      sheet.style.transition = '';
      sheet.style.transform = '';
    }, 360);
  }
})();
